var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('nav-bar'),_c('app-main'),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }